import { Injectable } from '@angular/core';

@Injectable()
export class BikePremiumCalculationService {

  getBikePremium(price: number): number | null {
    if (isNaN(price)) {
      return null;
    }

    if (price < 499.99) {
      return 69;
    } else if (price < 999.99) {
      return 119;
    } else if (price < 1499.99) {
      return 139;
    } else if (price < 1999.99) {
      return 169;
    } else if (price < 2499.99) {
      return 199;
    } else if (price < 2999.99) {
      return 219;
    } else if (price < 3999.99) {
      return 249;
    } else if (price < 4999.99) {
      return 299;
    } else if (price < 5999.99) {
      return 349;
    } else if (price < 6999.99) {
      return 399;
    } else if (price < 7999.99) {
      return 429;
    } else if (price < 8999.99) {
      return 459;
    } else if (price < 9999.99) {
      return 499;
    } else if (price < 12499.99) {
      return 599;
    } else if (price <= 15000) {
      return 699;
    }

    return null;
  }

  getEbikePremium(price: number): number | null {
    if (isNaN(price)) {
      return null;
    }

    if (price < 499.99) {
      return 49;
    } else if (price < 999.99) {
      return 69;
    } else if (price < 1499.99) {
      return 79;
    } else if (price < 1999.99) {
      return 89;
    } else if (price < 2499.99) {
      return 99;
    } else if (price < 2999.99) {
      return 109;
    } else if (price < 3999.99) {
      return 129;
    } else if (price < 4999.99) {
      return 189;
    } else if (price < 5999.99) {
      return 199;
    } else if (price < 6999.99) {
      return 229;
    } else if (price < 7999.99) {
      return 259;
    } else if (price < 8999.99) {
      return 299;
    } else if (price < 9999.99) {
      return 349;
    } else if (price < 12499.99) {
      return 499;
    } else if (price <= 15000) {
      return 599;
    }

    return null;
  }
}
